import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

const Page = () => {
    const router = useRouter();

    useEffect(() => {
        router.replace(Routes.PublicHome);
    }, [router]);

    return null;
};

export default Page;